import { VehicleTypes } from '@/enums/filters';
import axios from 'axios';
import { createRouter, createWebHistory } from 'vue-router';

const fetchFid = async (category, query) => {
  try {
    let url = `/${category}insurance/getRedisKey`;
    if (query) {
      url += `?${new URLSearchParams(query).toString()}`;
    }
    return await axios.get(url);
  } catch (error) {
    console.error('Error fetching fid:', error);
    throw error;
  }
};

const makeFormGuard = (vehicleType) => async (to, _from, next) => {
  const routeName = `${vehicleType}Form`;
  if (to.redirectedFrom?.name === routeName) {
    next();
    return;
  }
  try {
    const { data } = await fetchFid(vehicleType, to.query);
    next({ ...to, params: { ...to.params, fid: data } });
  } catch {
    next(false);
  }
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/form/car/:fid?',
      name: `${VehicleTypes.Car}Form`,
      component: () => import('../views/forms/car/index.vue'),
      beforeEnter: makeFormGuard(VehicleTypes.Car),
    },
    {
      path: '/form/bike/:fid?',
      name: `${VehicleTypes.Bike}Form`,
      component: () => import('../views/forms/bike/index.vue'),
      beforeEnter: makeFormGuard(VehicleTypes.Bike),
    },
    {
      path: '/form/truck/:fid?',
      name: `${VehicleTypes.Truck}Form`,
      component: () => import('../views/forms/truck/index.vue'),
      beforeEnter: makeFormGuard(VehicleTypes.Truck),
    },
    {
      path: '/form/rural/:fid?',
      name: `${VehicleTypes.Rural}Form`,
      component: () => import('../views/forms/rural/index.vue'),
      beforeEnter: makeFormGuard(VehicleTypes.Rural),
    },
    {
      path: '/form/taxi/:fid?',
      name: `${VehicleTypes.Taxi}Form`,
      component: () => import('../views/forms/taxi/index.vue'),
      beforeEnter: makeFormGuard(VehicleTypes.Taxi),
    },
    {
      path: '/form/rentalcar/:fid?',
      name: `${VehicleTypes.RentalCar}Form`,
      component: () => import('../views/forms/rentalcar/index.vue'),
      beforeEnter: makeFormGuard(VehicleTypes.RentalCar),
    },
    {
      path: '/results/:category/:fid',
      name: 'results',
      component: () => import('../views/ResultsView.vue'),
    },
    {
      path: '/compare',
      name: 'compare',
      component: () => import('../views/Compare.vue'),
    },
    {
      path: '/form/checkout',
      name: 'checkout',
      component: () => import('../views/checkouts/index.vue'),
    },
    {
      path: '/thankyou',
      name: 'thankyou',
      component: () => import('../views/Thankyou.vue'),
    },
    {
      path: '/upload/:offer_code?',
      name: 'upload',
      component: () => import('../views/checkouts/index.vue'),
    },
    {
      path: '/payment/:id?/:payment_code?',
      name: 'payment',
      component: () => import('../views/checkouts/index.vue'),
    }
  ],
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

export default router;